import { render, staticRenderFns } from "./BrigadeMapTaskCard.vue?vue&type=template&id=5914b93f&scoped=true&"
import script from "./BrigadeMapTaskCard.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./BrigadeMapTaskCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BrigadeMapTaskCard.vue?vue&type=style&index=1&id=5914b93f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914b93f",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QBadge,QBtn,QItem,QInput,QSelect,QSeparator,QInnerLoading,QSpinnerGears,QField} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QTooltip,QBadge,QBtn,QItem,QInput,QSelect,QSeparator,QInnerLoading,QSpinnerGears,QField}, component.options.components || {})
